import { eInvoiceMsg, emailInvoiceMsg, paperInvoiceMsg, t } from '../../common/i18n/index.js';
import { BillingAccountDeliveryMethod } from '../../generated/api/billingAccountDeliveryMethod.js';
import type { BillingAccountHeader } from '../../generated/api/billingAccountHeader.js';

interface BillingAccountHeaderInfoProps {
  billingAccountHeader: BillingAccountHeader;
}

export const BillingAccountHeaderInfo = ({ billingAccountHeader }: BillingAccountHeaderInfoProps) => {
  return (
    <>
      <div>{billingAccountHeader.billingAccountDisplayId}</div>
      <div>{billingAccountHeader.payerName}</div>
      <div>
        {billingAccountHeader.deliveryMethod === BillingAccountDeliveryMethod.EMAIL && t.NNV9(emailInvoiceMsg)}
        {billingAccountHeader.deliveryMethod === BillingAccountDeliveryMethod.ELECTRONIC && t.IK1D(eInvoiceMsg)}
        {billingAccountHeader.deliveryMethod === BillingAccountDeliveryMethod.PAPER && t.TER4(paperInvoiceMsg)}
      </div>
    </>
  );
};
